// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#firmware-uploader-dialog-container > .dialogBlock {
    width: 600px;
}

.firmware-uploader-dialog .theia-select {
    border: none !important;
}
.firmware-uploader-dialog .arduino-select__control {
    height: 31px;
    background: var(--theia-input-background) !important;
}

.firmware-uploader-dialog .dialogRow > button {
    margin-right: 3px;
}

.firmware-uploader-dialog #firmware-select {
    flex: unset;
}

.firmware-uploader-dialog .success {
    color: #1da086;
}

.firmware-uploader-dialog .warn {
    color: #c11f09;
}

.firmware-uploader-dialog .status-icon {
    margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/firmware-uploader-dialog.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["#firmware-uploader-dialog-container > .dialogBlock {\r\n    width: 600px;\r\n}\r\n\r\n.firmware-uploader-dialog .theia-select {\r\n    border: none !important;\r\n}\r\n.firmware-uploader-dialog .arduino-select__control {\r\n    height: 31px;\r\n    background: var(--theia-input-background) !important;\r\n}\r\n\r\n.firmware-uploader-dialog .dialogRow > button {\r\n    margin-right: 3px;\r\n}\r\n\r\n.firmware-uploader-dialog #firmware-select {\r\n    flex: unset;\r\n}\r\n\r\n.firmware-uploader-dialog .success {\r\n    color: #1da086;\r\n}\r\n\r\n.firmware-uploader-dialog .warn {\r\n    color: #c11f09;\r\n}\r\n\r\n.firmware-uploader-dialog .status-icon {\r\n    margin-right: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
